export interface PublicInstallment {
  sequence: number;
  label: string | null;
  amount: number;
  due_date: string | null;
  status: string;
}

export interface InstallmentSummaryRow {
  label: string;
  amount: number;
}

/**
 * Collapses a payment plan into the rows shown on the signing page:
 * "Entrada X%" + "Saldo em Nx" (or "Pagamento único"). Total is rendered by
 * the caller, so it is not included here.
 */
export function summarizeInstallments(
  installments: PublicInstallment[],
  total: number,
): InstallmentSummaryRow[] {
  const sorted = [...installments]
    .filter((i) => i.status !== "canceled")
    .sort((a, b) => a.sequence - b.sequence);
  if (sorted.length === 0) return [];

  if (sorted.length === 1) {
    return [{ label: "Pagamento único", amount: sorted[0].amount }];
  }

  const [first, ...rest] = sorted;
  const base = total > 0 ? total : sorted.reduce((s, i) => s + i.amount, 0);
  const pct = base > 0 ? Math.round((first.amount / base) * 100) : 0;
  const balance = rest.reduce((s, i) => s + i.amount, 0);

  return [
    { label: pct > 0 ? `Entrada ${pct}%` : "Entrada", amount: first.amount },
    { label: `Saldo em ${rest.length}x`, amount: balance },
  ];
}
